import { render, staticRenderFns } from "./AirdropBalance.vue?vue&type=template&id=32a826a0&scoped=true"
import script from "./AirdropBalance.vue?vue&type=script&lang=js"
export * from "./AirdropBalance.vue?vue&type=script&lang=js"
import style0 from "./AirdropBalance.vue?vue&type=style&index=0&id=32a826a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a826a0",
  null
  
)

export default component.exports